import type { Reducer } from '@reduxjs/toolkit'

export const RESET_APP_STATE = 'app/resetState'

type SharedStore = {
  getState: () => any
  dispatch: (action: unknown) => unknown
}

let storeRef: SharedStore | null = null

export function setSharedStore(store: SharedStore) {
  storeRef = store
}

export function getSharedStore() {
  if (!storeRef) {
    throw new Error(
      '@gusiberi/shared: call setSharedStore() before using store-backed API helpers'
    )
  }
  return storeRef
}

/** Wipes Redux + RTK Query cache. Safe to call before the store exists. */
export function resetSharedStore() {
  storeRef?.dispatch({ type: RESET_APP_STATE })
}

export function withResetOnLogout<S>(reducer: Reducer<S>): Reducer<S> {
  return (state, action) => {
    if (action.type === RESET_APP_STATE) {
      return reducer(undefined, action)
    }
    return reducer(state, action)
  }
}
